export default {"src":"/_next/static/media/teapot.ca120a54.gif","height":1200,"width":1600,"blurWidth":0,"blurHeight":0};